// import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import GlobalTableGenerator from '../../../../components/GlobalTableGenerator';
import { tutorSlotUtilizationTableHead } from '../utils/TutorManagementHeaders';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTutorUtilizationTable } from '../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';

export default function TutorSlotUtilizationTable({ fromDate, toDate, project }) {
  const [tab, setTab] = useState(0);

  const tutorUtilizationTable = useSelector((state) => state.crd.tutorUtilizationTable.data);
  const tutorUtilizationTableLoading = useSelector((state) => state.crd.tutorUtilizationTable.loading);

  const dispatch = useDispatch();
  useEffect(() => {
    const params = {
      fromDate,
      toDate,
      project_id: project === -1 ? null : project,
      type: Boolean(tab) ? 'syllabus' : 'subject',
    };
    dispatch(getTutorUtilizationTable(params));
  }, [fromDate, toDate, project, tab, dispatch]);

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 2 }} elevation={3}>
      <Typography variant="h5" mb={2}>
        Tutor Slot Utilization
      </Typography>
      <Tabs
        onChange={(_, v) => setTab(v)}
        value={tab}
        sx={{
          bgcolor: '#F3F4F6',
          width: 'fit-content',
          borderRadius: 3,
          p: 1,

          '& .Mui-selected': {
            bgcolor: '#FFFFFF',
            height: 'fit-content',
            borderRadius: 2,
          },
        }}
        indicatorColor="transparent"
      >
        <Tab label="Subject-wise" value={0} />
        <Tab label="Syllabus-wise" value={1} />
      </Tabs>
      <GlobalTableGenerator
        TableHeadStyle={{ bgcolor: '#F9FAFB' }}
        columns={tutorSlotUtilizationTableHead({ type: tab })}
        rows={tutorUtilizationTable}
        loading={tutorUtilizationTableLoading}
        pagination
        searchOption
        searchBy={[tab ? 'syllabus_name' : 'subject_name']}
      />
    </Paper>
  );
}
